export default __webpack_public_path__ + "static/media/livingroomland.14d795fc.jpg";